import React, { ComponentProps } from 'react'
import TextButton from 'LuxKit/Button/TextButton'
import { useAppDispatch } from 'hooks/reduxHooks'
import { addToUserCart } from 'actions/UserCartActions'
import LineShoppingCartIcon from 'LuxKit/Icons/line/LineShoppingCartIcon'
import { initialiseCheckout } from 'actions/CheckoutActions'
import { navigateToCheckout } from 'checkout/actions/navigateActions'
import OfferCheckoutButton from './OfferCheckoutButton'
import { isFlightItem } from 'lib/checkout/checkoutUtils'
import { addToCartWithContext, hotelItemContextByPackageView } from 'analytics/snowplow/events'
import * as Analytics from 'analytics/analytics'
import { isNonNullable } from 'lib/array/arrayUtils'

interface Props extends Omit<ComponentProps<typeof TextButton>, 'kind' | 'children'> {
  packageView: App.OfferPackageOptionView
  overrideRooms?: Array<App.RoomOccupants | App.Occupants>
  onSubmit?: () => void
}

function OfferAddToCartButton(props: Props) {
  const {
    packageView,
    onSubmit,
    overrideRooms,
    ...rest
  } = props

  const dispatch = useAppDispatch()

  const onProceedToBooking = (items: Array<App.Checkout.AnyItem>) => {
    const flights = items.some(isFlightItem)
    if (flights) {
      // Pick regular flow and final decision to pay or only add to cart to be made at end of flight selection
      dispatch(initialiseCheckout(items, { mode: 'vertical-select' }))
      dispatch(navigateToCheckout({ skipSpoofedModal: true }))
    } else {
      const contextItems = items
        .map(item => hotelItemContextByPackageView(item, packageView, true))
        .filter(isNonNullable)
      Analytics.trackEvent(addToCartWithContext(contextItems))

      dispatch(addToUserCart(items))
    }
  }

  return (
    <OfferCheckoutButton
      {...rest}
      kind="secondary"
      startIcon={<LineShoppingCartIcon />}
      onSubmit={onSubmit}
      overrideRooms={overrideRooms}
      packageView={packageView}
      onProceedToBooking={onProceedToBooking}
      upgradeEnabled={false}
      disablePrefetchExperiences
    >
      Add to cart
    </OfferCheckoutButton>
  )
}

export default OfferAddToCartButton
